/* eslint-disable no-underscore-dangle */
import { Button, Col, Form, Row, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Title } from '../../Utils/Text';
import { getUser, getUsers } from '../Application/Users.business';
import { getUsersSelector } from '../Infrastructure/Users.reducer';
import { secondary } from '../../Utils/Colors';

const { Option } = Select;

const styles = {
  container: {},
  background: {
    margin: '0.7em 0em',
    borderRadius: '15px',
    padding: '1em',
    boxShadow: '3px 5px 5px 1px rgb(213,196,233, 0.5)',
  },
  button: {
    borderRadius: 25,
    backgroundColor: secondary,
  },
};

// eslint-disable-next-line react/prop-types
export default function Searcher() {
  const records = useSelector(getUsersSelector);
  const history = useHistory();
  const [form] = Form.useForm();

  const onFinish = async ({ id }) => {
    getUser(id);
    history.push(`/users/${id}`);
  };

  const onReset = () => {
    form.resetFields();
  };

  function onSearch(val) {
    getUsers({ q: val });
  }
  return (
    <div style={styles.container}>
      <Row>
        <Col span={24}>
          <Title>Usuarios</Title>
        </Col>
        <Col span={24}>
          <div style={styles.background}>
            <Form form={form} layout="inline" onFinish={onFinish} onReset={onReset}>
              <Form.Item name="id" label="Usuario">
                <Select
                  clearIcon
                  showSearch
                  style={{ width: 300 }}
                  placeholder="Selecciona un usuario"
                  optionFilterProp="children"
                  /* eslint-disable-next-line react/jsx-no-bind */
                  onSearch={onSearch}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {records?.map((record) => (
                    <Option value={record.id} key={record.id}>
                      {record.username || record.email}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Button type="primary" htmlType="submit" style={styles.button}>
                Seleccionar
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
}
